import { getAccessToken } from "@mindlercare/auth";
import { createClient } from "@mindlercare/mindlerapi-client";
import { getMarketBasedRegion } from "../helpers/getCountryCode";
import { auth } from "../services/auth";

const stage = import.meta.env.VITE_STAGE;
const overrideUrl = import.meta.env.VITE_APIV2_URL;

export const getMindlerApiV2Client = () => {
  const clientConfig = overrideUrl
    ? { url: overrideUrl }
    : {
        region: getMarketBasedRegion(),
        stage,
      };

  return createClient({
    ...clientConfig,
    logRequests: true,
    getJwtToken: () => getAccessToken(auth),
  });
};
